function initJaeBestSellerCarousel() {
  const swiperContainers = document.querySelectorAll('.jae-best-seller__swiper');
  
  swiperContainers.forEach(function(container) {
    const section = container.closest('.jae-best-seller');
    const prevButton = section.querySelector('.jae-best-seller__button--prev');
    const nextButton = section.querySelector('.jae-best-seller__button--next');
    const wrapper = container.querySelector('.swiper-wrapper');

    const navigationConfig = (prevButton && nextButton) ? {
      prevEl: prevButton,
      nextEl: nextButton,
    } : false;

    let isHovering = false;
    let isAnimatingOffset = false;

    const offsetConfig = {
      mobile: 0,   
      tablet: 20,   
      desktop: 60,
      large:0   
    };

    const swiper = new Swiper(container, {
      slidesPerView: 2,
      spaceBetween: 12,
      loop: false,
      speed: 600,
      resistanceRatio: 0.85,
      grabCursor: true,
      longSwipesRatio: 0.5,
      threshold: 10,
      navigation: navigationConfig,
      slidesOffsetBefore: offsetConfig.mobile,
      breakpoints: {
        576: { slidesPerView: 2, spaceBetween: 12, slidesOffsetBefore: offsetConfig.mobile },
        769: { slidesPerView: 2.5, spaceBetween: 12, slidesOffsetBefore: offsetConfig.tablet },
        992: { slidesPerView: 3.25, spaceBetween: 12, slidesOffsetBefore: offsetConfig.desktop },
        1440: { slidesPerView: 3.75, spaceBetween: 12, slidesOffsetBefore: offsetConfig.desktop },
        1600: { slidesPerView: 4, spaceBetween: 12, slidesOffsetBefore: offsetConfig.large },
      },
      on: {
        init: function () {
          if (prevButton && nextButton) {
            updateNavigationState(this, prevButton, nextButton);
          }
          const currentOffset = getCurrentOffset();
          this.params.slidesOffsetBefore = currentOffset;
        },
        slideChange: function () {
          if (prevButton && nextButton) {
            updateNavigationState(this, prevButton, nextButton);
          }
        },
        slideChangeTransitionEnd: function () {
          
          if (this.activeIndex !== 0) {
            showButtons(section);
            if (!isAnimatingOffset) {
              setDynamicOffsetSmooth(this, wrapper, 0);
            }
          } else {
            const currentOffset = getCurrentOffset();
            if (!isAnimatingOffset) {
              setDynamicOffsetSmooth(this, wrapper, currentOffset);
            }
            if (!isHovering) {
              hideButtons(section);
            }
          }
        }
      },
    });

    function getCurrentOffset() {
      const width = window.innerWidth;
      if (width < 576) return offsetConfig.mobile;
      if (width < 769) return offsetConfig.tablet;
      if (width < 1600) return offsetConfig.desktop;
      return offsetConfig.large;
    }

    function setDynamicOffsetSmooth(swiperInstance, wrapperElement, targetOffset) {
      const currentOffset = swiperInstance.params.slidesOffsetBefore;
      
      if (currentOffset === targetOffset) return;
      if (isAnimatingOffset) return;
      
      isAnimatingOffset = true;

      const offsetDiff = targetOffset - currentOffset;
      const currentTransform = wrapperElement.style.transform;
      const translateMatch = currentTransform.match(/translate3d\(([^,]+),/);
      const currentTranslate = translateMatch ? parseFloat(translateMatch[1]) : 0;
      
      wrapperElement.style.transition = 'transform 600ms cubic-bezier(0.4, 0, 0.2, 1)';
      wrapperElement.style.transform = `translate3d(${currentTranslate + offsetDiff}px, 0, 0)`;
      
       setTimeout(() => {
        swiperInstance.params.slidesOffsetBefore = targetOffset;
        wrapperElement.style.transition = '';
        wrapperElement.style.transform = '';
        swiperInstance.update();
        isAnimatingOffset = false;
      }, 600);
    }

    section.addEventListener('mouseenter', () => {
      isHovering = true;
      showButtons(section);
    });

    section.addEventListener('mouseleave', () => {
      isHovering = false;
      if (swiper.activeIndex === 0) {
        hideButtons(section);
      }
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (swiper.activeIndex === 0 && !isAnimatingOffset) {
          const currentOffset = getCurrentOffset();
          if (swiper.params.slidesOffsetBefore !== currentOffset) {
            swiper.params.slidesOffsetBefore = currentOffset;
            swiper.update();
          }
        }
      }, 150);
    });
  });

  function updateNavigationState(swiper, prevButton, nextButton) {
    if (!prevButton || !nextButton) return;
    swiper.isBeginning ? prevButton.setAttribute('disabled', 'disabled') : prevButton.removeAttribute('disabled');
    swiper.isEnd ? nextButton.setAttribute('disabled', 'disabled') : nextButton.removeAttribute('disabled');
  }

  function showButtons(section) {
    section.classList.add('jae-best-seller__buttons-visible');
  }

  function hideButtons(section) {
    section.classList.remove('jae-best-seller__buttons-visible');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initJaeBestSellerCarousel);
} else {
  initJaeBestSellerCarousel();
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target;
    if (section.querySelector('.jae-best-seller__swiper')) {
      initJaeBestSellerCarousel();
    }
  });
}
